export const FONT_AWESOME_ICONS = [
    { label: 'Inicio', value: 'fas fa-home' },
    { label: 'Usuarios', value: 'fas fa-users' },
    { label: 'Usuario', value: 'fas fa-user' },
    { label: 'Configuración', value: 'fas fa-cog' },
    { label: 'Engranajes', value: 'fas fa-cogs' },
    { label: 'Escudo / Roles', value: 'fas fa-shield-alt' },
    { label: 'Llave / Acceso', value: 'fas fa-key' },
    { label: 'Candado', value: 'fas fa-lock' },
    { label: 'Lista', value: 'fas fa-list' },
    { label: 'Tabla', value: 'fas fa-table' },
    { label: 'Gráfico Barras', value: 'fas fa-chart-bar' },
    { label: 'Gráfico Tarta', value: 'fas fa-chart-pie' },
    { label: 'Gráfico Línea', value: 'fas fa-chart-line' },
    { label: 'Archivo', value: 'fas fa-file' },
    { label: 'Archivo Alt', value: 'fas fa-file-alt' },
    { label: 'Carpeta', value: 'fas fa-folder' },
    { label: 'Carpeta Abierta', value: 'fas fa-folder-open' },
    { label: 'Búsqueda', value: 'fas fa-search' },
    { label: 'Guardar', value: 'fas fa-save' },
    { label: 'Editar', value: 'fas fa-edit' },
    { label: 'Papelera', value: 'fas fa-trash' },
    { label: 'Plus / Agregar', value: 'fas fa-plus' },
    { label: 'Check / OK', value: 'fas fa-check' },
    { label: 'Times / Cerrar', value: 'fas fa-times' },
    { label: 'Info', value: 'fas fa-info-circle' },
    { label: 'Exclamación', value: 'fas fa-exclamation-triangle' },
    { label: 'Interrogación', value: 'fas fa-question-circle' },
    { label: 'Caja / Entidad', value: 'fas fa-box' },
    { label: 'Cajas', value: 'fas fa-boxes' },
    { label: 'Edificio', value: 'fas fa-building' },
    { label: 'Maleta / Negocios', value: 'fas fa-briefcase' },
    { label: 'Camión / Logística', value: 'fas fa-truck' },
    { label: 'Coche / Vehículo', value: 'fas fa-car' },
    { label: 'Etiqueta', value: 'fas fa-tag' },
    { label: 'Etiquetas', value: 'fas fa-tags' },
    { label: 'Calendario', value: 'fas fa-calendar-alt' },
    { label: 'Reloj', value: 'fas fa-clock' },
    { label: 'Mundo / Web', value: 'fas fa-globe' },
    { label: 'Enlace', value: 'fas fa-link' },
    { label: 'Correo', value: 'fas fa-envelope' },
    { label: 'Teléfono', value: 'fas fa-phone' },
    { label: 'Campana / Notif', value: 'fas fa-bell' },
    { label: 'Ojo / Ver', value: 'fas fa-eye' },
    { label: 'Impresora', value: 'fas fa-print' },
    { label: 'Descargar', value: 'fas fa-download' },
    { label: 'Subir', value: 'fas fa-upload' },
    { label: 'Dinero', value: 'fas fa-money-bill-wave' },
    { label: 'Tarjeta', value: 'fas fa-credit-card' },
    { label: 'Wallet', value: 'fas fa-wallet' },
    { label: 'Estrella', value: 'fas fa-star' },
    { label: 'Corazón', value: 'fas fa-heart' },
    { label: 'Imagen', value: 'fas fa-image' },
    { label: 'Map', value: 'fas fa-map-marker-alt' },
    { label: 'Cerrar Sesión', value: 'fas fa-sign-out-alt' },
    { label: 'Jerarquía', value: 'fas fa-folder-tree' },
    { label: 'Mapa de sitio', value: 'fas fa-sitemap' },
];
